/**
 * 权限详情弹窗配置
 */

// 权限详情弹窗配置
export const permissionModalConfig = {
  size: {
    width: 600,
    height: "60vh",
    maxWidth: "95vw",
    minWidth: 600,
  },
  searchConfig: {
    enabled: true,
    placeholder: "搜索权限名称、编码或服务...",
  },
  selectionConfig: {
    enabled: false,
  },
  actionConfig: {
    showCancel: false, // 不显示取消按钮
    showClose: true, // 显示关闭按钮
    closeText: "关闭", // 关闭按钮文本
  },
  treeConfig: {
    defaultExpandAll: true,
    showLine: true,
    showIcon: true,
  },
  modalProps: {
    maskClosable: false,
    destroyOnClose: true,
  },
};

